document.addEventListener("DOMContentLoaded", function () {
    function generateYardDropdown(tags, availableInventory, variantName, pricePerUnit) {
        var dropdown = document.getElementById("yard-selector");
        var yardIncrementText = document.getElementById("yard-increment");
        var yardStepText = document.getElementById("yard-step");

        if (!dropdown) {
            console.error("yard-selector element not found.");
            return;
        }

        dropdown.innerHTML = ""; // Clear existing options

        // Determine base quantity
        var baseQty = 1; // Default whole units
        if (tags.includes("base_qty_0.5") || (variantName && parseFloat(variantName) === 0.5)) {
            baseQty = 0.5;
        }

        // Update UI elements with correct increment
        if (yardIncrementText) yardIncrementText.textContent = baseQty;
        if (yardStepText) yardStepText.textContent = baseQty;

        // Calculate maximum selectable yards
        var maxYards = Math.min(availableInventory * baseQty, 10);

        // Generate dropdown options dynamically
        for (var i = baseQty; i <= maxYards; i += baseQty) {
            var option = document.createElement("option");
            option.value = i / baseQty; // Inventory unit value
            option.textContent = i + " yards";
            dropdown.appendChild(option);
        }

        // Set initial total price
        updateTotalPrice();
    }

    function updateTotalPrice() {
        var dropdown = document.getElementById("yard-selector");
        var totalPriceSpan = document.getElementById("total-price");
        var yardageData = document.getElementById("yardage-data");
    
        if (!dropdown || !totalPriceSpan || !yardageData) {
            console.error("One or more elements missing in updateTotalPrice.");
            return;
        }
    
        var pricePerUnit = parseFloat(yardageData.dataset.price) / 100; // Convert cents to dollars
        if (isNaN(pricePerUnit)) {
            console.error("Price per unit is invalid:", yardageData.dataset.price);
            return;
        }
    
        var selectedYards = parseFloat(dropdown.value);
        if (isNaN(selectedYards)) {
            console.error("Selected yards is invalid:", dropdown.value);
            return;
        }
    
        var totalPrice = selectedYards * pricePerUnit;
    
        // Format price to always show two decimal places
        totalPriceSpan.textContent = `$${totalPrice.toFixed(2)}`;
    }
    

    function setupAddToCart() {
        var addToCartButton = document.getElementById("add-to-cart-button");
        if (!addToCartButton) {
            console.error("add-to-cart-button element not found.");
            return;
        }
    
        addToCartButton.addEventListener("click", function () {
            var yardageData = document.getElementById("yardage-data");
            var yardSelector = document.getElementById("yard-selector");
    
            if (!yardageData || !yardSelector) {
                console.error("yardage-data or yard-selector element not found.");
                return;
            }
    
            var selectedYards = parseFloat(yardSelector.value);
            var variantId = yardageData.dataset.variantId; // Ensure this is available
    
            if (!variantId) {
                console.error("Variant ID not found!");
                return;
            }
    
            // Shopify requires 'id' and 'quantity' in the cart request
            var formData = {
                id: variantId,
                quantity: selectedYards
            };
    
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(response => response.json())
            .then(data => {
                console.log("Added to cart:", data);
                window.location.href = "/cart"; // Redirect to cart page after adding
            })
            .catch(error => {
                console.error("Error adding to cart:", error);
            });
        });
    }
    

    function initializeYardageSelector() {
        var yardageData = document.getElementById("yardage-data");
        if (yardageData) {
            var productTags = yardageData.dataset.tags;
            var availableInventory = parseInt(yardageData.dataset.inventory, 10);
            var variantName = yardageData.dataset.variantName;
            var pricePerUnit = parseInt(yardageData.dataset.price, 10);

            generateYardDropdown(productTags, availableInventory, variantName, pricePerUnit);

            // Attach event listener to dropdown for price updates
            setTimeout(function () {
                var yardSelector = document.getElementById("yard-selector");
                if (yardSelector) {
                    yardSelector.addEventListener("change", updateTotalPrice);
                } else {
                    console.error("yard-selector not found when trying to attach event listener.");
                }

                setupAddToCart();
            }, 500);
        } else {
            console.error("yardage-data element not found. Ensure it is rendered in the HTML.");
        }
    }

    setTimeout(initializeYardageSelector, 500);
});
